import { connect } from 'react-redux';
import Page from '../pages/Page';
import { clickOnBrowseEvents as clickOnBrowseEventsAction } from '../actions/events';
import { getOrganizerIds } from '../selectors';
import { clickOnLikeToggle as clickOnLikeToggleAction } from '../actions/events';

const _mapStateToProps = (state) => ({
    isLoading: state.isLoading,
    isOwner: state.collection.canCurate,
    collectionName: state.collection.name,
    userId: state.userId,
    organizerIds: getOrganizerIds(state),
    gaSettings: state.gaSettings,
    gaCategory: 'editorial-collection',
    isAuthenticated: state.isAuthenticated,
    showFeaturedOrganizers: state.featureFlags.launchFollowOrganizerCollections,
});

const _mapDispatchToProps = {
    handleClickBrowseEvents: clickOnBrowseEventsAction,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(Page);
